$(document).ready(function() {
    $('.sub_collection-list[data-slider-wrapper]').each(function(index, element) {
      var $sliderBox = $(element).find('.scrollbar');
      
      if ($sliderBox.length === 0 || $sliderBox.hasClass('slick-initialized')) return;
      
      $sliderBox.on('init', function(event, slick){
        $(element).removeClass('hide-till-slick-loaded');
      });
      
      $sliderBox.slick({
        autoplay: false,
        speed: 300,
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 2,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="ri-arrow-left-line"></i></button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="ri-arrow-right-line"></i></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          }
        ],
      });
      
      if ($sliderBox.hasClass('slick-initialized')) {
        $(element).removeClass('hide-till-slick-loaded');
      }
    });
});